module.exports = __webpack_public_path__ + "media/site_templates/www.localcarpenters.net.au/images/feature_2-4703f5aa2d08c4d248f42c239b4f48c5.jpeg";